import React from "react";
import PropTypes from "prop-types";
import get from "lodash.get";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

import ParkkiTheme from "themes/ParkkiTheme";
import ReportsActioner from "services/reports/actioner";
import Section from "components/Section";
import PDFList from "../pdfList";

const styles = {
  container: {
    display: "flex",
    flex: 1,
    backgroundColor: ParkkiTheme.colors.lightGrey,
    flexDirection: "column",
  },
  hebdoContainer: {},
  monthlyContainer: {},
};

class AnalysisLayout extends React.Component {
  initPageData = () => {
    const { retrieveReports } = this.props;
    retrieveReports();
  };

  componentDidMount = () => {
    this.initPageData();
  };

  componentDidUpdate = (prevProps) => {
    const { contract } = this.props;

    if (
      get(prevProps, "contract.id") &&
      get(contract, "id") !== get(prevProps, "contract.id")
    ) {
      this.initPageData();
    }
  };

  render() {
    const {
      intl,
      monthlyReports,
      setMonthlyHoverIndex,
      setWeeklyHoverIndex,
      setMonthlySelectedIndex,
      setWeeklySelectedIndex,
      setMonthlyPage,
      setWeeklyPage,
      setMonthlyRowsPerPage,
      setWeeklyRowsPerPage,
      weeklyReports,
    } = this.props;

    return (
      <div style={styles.container}>
        <Section
          title={intl.messages["analysisScene.hebdo"]}
          style={styles.hebdoContainer}
        >
          <PDFList
            loading={!get(weeklyReports, "initialized", false)}
            list={weeklyReports}
            onRowHover={setWeeklyHoverIndex}
            onRowSelection={(index) => {
              setMonthlySelectedIndex(null);
              setWeeklySelectedIndex(index);
            }}
            setPage={setWeeklyPage}
            setRowsPerPage={setWeeklyRowsPerPage}
          />
        </Section>

        <Section
          title={intl.messages["analysisScene.monthly"]}
          style={styles.monthlyContainer}
        >
          <PDFList
            loading={!get(monthlyReports, "initialized", false)}
            list={monthlyReports}
            onRowHover={setMonthlyHoverIndex}
            onRowSelection={(index) => {
              setWeeklySelectedIndex(null);
              setMonthlySelectedIndex(index);
            }}
            setPage={setMonthlyPage}
            setRowsPerPage={setMonthlyRowsPerPage}
          />
        </Section>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  contract: state.Contract.contract,
  monthlyReports: get(state, "Reports.monthlyList", []),
  weeklyReports: get(state, "Reports.weeklyList", []),
});

const mapDispatchToProps = (dispatch) => ({
  retrieveReports: () =>
    dispatch(ReportsActioner.retrieveReportsForAnalysisTab()),
  setWeeklyHoverIndex: (index) =>
    dispatch(ReportsActioner.setHoverIndex("weeklyList", index)),
  setMonthlyHoverIndex: (index) =>
    dispatch(ReportsActioner.setHoverIndex("monthlyList", index)),
  setWeeklySelectedIndex: (index) =>
    dispatch(ReportsActioner.setSelectedIndex("weeklyList", index)),
  setMonthlySelectedIndex: (index) =>
    dispatch(ReportsActioner.setSelectedIndex("monthlyList", index)),
  setWeeklyPage: (page) =>
    dispatch(ReportsActioner.setPage("weeklyList", page)),
  setMonthlyPage: (page) =>
    dispatch(ReportsActioner.setPage("monthlyList", page)),
  setWeeklyRowsPerPage: (rowsPerPage) =>
    dispatch(ReportsActioner.setRowsPerPage("weeklyList", rowsPerPage)),
  setMonthlyRowsPerPage: (rowsPerPage) =>
    dispatch(ReportsActioner.setRowsPerPage("monthlyList", rowsPerPage)),
});

AnalysisLayout.defaultProps = {};

AnalysisLayout.propTypes = {
  monthlyReports: PropTypes.object.isRequired,
  weeklyReports: PropTypes.object.isRequired,
  retrieveReports: PropTypes.func.isRequired,
  setMonthlyHoverIndex: PropTypes.func.isRequired,
  setWeeklyHoverIndex: PropTypes.func.isRequired,
  setWeeklyPage: PropTypes.func.isRequired,
  setMonthlyPage: PropTypes.func.isRequired,
  setWeeklyRowsPerPage: PropTypes.func.isRequired,
  setMonthlyRowsPerPage: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(AnalysisLayout));
